import PostExcelRequestModelBase from '../_generated/modelBases/post-excel-request-model-base';

export default class PostExcelRequestModel extends PostExcelRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
